/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_SessionInputs */

const en_loading_session = /** @type {(inputs: Loading_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading session`)
};

const pt_br2_loading_session = /** @type {(inputs: Loading_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando sessão`)
};

/**
* | output |
* | --- |
* | "Loading session" |
*
* @param {Loading_SessionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const loading_session = /** @type {((inputs?: Loading_SessionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_SessionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loading_session(inputs)
	return pt_br2_loading_session(inputs)
});